import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as validate from 'utils/validation';
import * as _ from 'lodash';
import { changeCCValidation, setFormValue, validateStep2 } from 'redux/modules/newClient';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { Tooltip } from 'components';
import * as styles from './NewLocation.scss';
var NewLocationFormStep2 = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    validationFields: state.newClient.validationFields,
    invalidFields: state.newClient.invalidFields,
    step2FirstPass: state.newClient.validation.step2FirstPass,
    stripeError: state.billing.billingError
  };
}, {
  changeCCValidation: changeCCValidation,
  setFormValue: setFormValue,
  validateStep2: validateStep2
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewLocationFormStep2, _Component);

  var _super = _createSuper(NewLocationFormStep2);

  function NewLocationFormStep2() {
    var _this;

    _classCallCheck(this, NewLocationFormStep2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleTextFieldChange", function (e, val) {
      _this.props.setFormValue(e.target.id, 'orgDetails', val);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCardFieldChange", function (e, val) {
      _this.props.setFormValue(e.target.id, 'cc', val);
    });

    _defineProperty(_assertThisInitialized(_this), "generateErrorText", function (fieldName) {
      var errorText = ''; // only show error text after 'next' button has been clicked

      if (!_this.props.step2FirstPass) {
        if (_this.props.validationFields.includes(fieldName)) {
          if (_this.props.invalidFields.includes(fieldName)) {
            errorText = 'Required field';
          }
        }
      }

      return errorText;
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (label, fieldName, value, key) {
      var errorText = _this.generateErrorText(label);

      var displayText = _.startCase(label);

      if (_this.props.validationFields.includes(label)) {
        displayText += '*';
      }

      return /*#__PURE__*/React.createElement(TextField, {
        key: key,
        errorText: errorText,
        floatingLabelText: displayText,
        hintText: displayText,
        id: fieldName,
        value: value,
        onChange: _this.handleTextFieldChange,
        style: {
          marginRight: 8,
          marginLeft: 8,
          flex: '1 1 auto',
          minWidth: 155,
          width: 0
        }
      });
    });

    return _this;
  }

  _createClass(NewLocationFormStep2, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$props = this.props,
          formValues = _this$props.formValues,
          orgConfig = _this$props.orgConfig;
      var partnerPaysAll = formValues && formValues.locationBillingInfo && formValues.locationBillingInfo.licenseFeeBillTo === 'partner' && formValues.locationBillingInfo.adsBillTo === 'partner'; // set the validation fields to either include credit card fields or not

      formValues.locationBillingInfo.licenseFeeBillTo === 'existing' || partnerPaysAll ? this.props.changeCCValidation(false) : this.props.changeCCValidation(true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          formValues = _this$props2.formValues,
          orgConfig = _this$props2.orgConfig;
      var partnerPaysAll = orgConfig && formValues.locationBillingInfo && formValues.locationBillingInfo.licenseFeeBillTo === 'partner' && formValues.locationBillingInfo.adsBillTo === 'partner';

      if (formValues.locationBillingInfo.licenseFeeBillTo !== 'existing' && !partnerPaysAll) {
        this.props.validateStep2();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          contractInfo = _this$props3.contractInfo,
          formValues = _this$props3.formValues;
      var partnerName = contractInfo ? contractInfo.contract.businessName : 'Partner';
      var partnerPaysAll = this.props.formValues && this.props.formValues.locationBillingInfo && (this.props.formValues.locationBillingInfo.licenseFeeBillTo === 'partner' || this.props.formValues.locationBillingInfo.licenseFeeBillTo === 'existing') && this.props.formValues.locationBillingInfo.adsBillTo === 'partner';
      console.log('&^#%$^$^&$^$^&$');
      console.log('&^#%$^$^&$^$^&$');
      console.log("partnerPaysAll in step 2 = ".concat(partnerPaysAll));
      console.log(partnerPaysAll);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
        className: styles.formSection,
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Location Details"), this.renderInput('First Name', 'firstName', this.props.formValues.orgDetails.firstName, 'firstName_textField'), this.renderInput('lastName', 'lastName', this.props.formValues.orgDetails.lastName, 'lastName_textField'), this.renderInput('email', 'email', this.props.formValues.orgDetails.email, 'email_textField'), this.renderInput('businessName', 'businessName', this.props.formValues.orgDetails.businessName, 'businessName_textField')), !partnerPaysAll && /*#__PURE__*/React.createElement("section", {
        className: styles.formSection,
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Location Credit Card"), this.props.stripeError && this.props.stripeError !== '' && /*#__PURE__*/React.createElement("div", {
        className: styles.errorBox
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.stripeError
      }, this.props.stripeError)), /*#__PURE__*/React.createElement(TextField, {
        id: "cardNumber",
        "data-private": "lipsum",
        errorText: this.generateErrorText('cardNumber'),
        hintText: "Card Number*",
        floatingLabelText: "Card Number*",
        value: this.props.formValues.cc.cardNumber,
        onChange: this.handleCardFieldChange,
        style: {
          marginRight: 8,
          marginLeft: 8,
          flex: '1 1 100%',
          width: 'auto'
        }
      }), /*#__PURE__*/React.createElement(TextField, {
        id: "expMonth",
        "data-private": "lipsum",
        errorText: this.generateErrorText('expMonth'),
        hintText: "Exp. Month (MM)*",
        floatingLabelText: "Exp. Month (MM)*",
        value: this.props.formValues.cc.expMonth,
        onChange: this.handleCardFieldChange,
        style: {
          marginRight: 8,
          marginLeft: 8,
          flex: '1',
          minWidth: 155,
          width: 'auto'
        }
      }), /*#__PURE__*/React.createElement(TextField, {
        id: "expYear",
        "data-private": "lipsum",
        errorText: this.generateErrorText('expYear'),
        hintText: "Exp. Year (YY)*",
        floatingLabelText: "Exp. Year (YY)*",
        value: this.props.formValues.cc.expYear,
        onChange: this.handleCardFieldChange,
        style: {
          marginRight: 8,
          marginLeft: 8,
          flex: '1',
          minWidth: 155,
          width: 'auto'
        }
      }), /*#__PURE__*/React.createElement(TextField, {
        id: "cvv",
        "data-private": "lipsum",
        errorText: this.generateErrorText('cvv'),
        hintText: "CVV*",
        floatingLabelText: "CVV*",
        value: this.props.formValues.cc.cvv,
        onChange: this.handleCardFieldChange,
        style: {
          marginRight: 8,
          marginLeft: 8,
          flex: '1',
          minWidth: 155,
          maxWidth: '50%',
          width: 'auto'
        }
      })));
    }
  }]);

  return NewLocationFormStep2;
}(Component)) || _class);
export { NewLocationFormStep2 as default };